export class AppointmentsResponseModel {
  weekday: string;
  hourFrom: string;
  hourTo: string;
  url: string;
  description: string;
  active: boolean;
  cancelReason: string;
  live?: boolean;
}

export class DashboardDataModel {
  totalInsuranceContracts: number;
  totalOtherContracts: number;
  totalInsuranceVolume: number;
}

/** FIN-7177 "Abschlüsse nach Ereignissen": GET /b2b/dashboard/event-conversions */
export class EventConversionItemModel {
  clientId: string;
  eventId: string;
  eventType: string;
  eventDisplayName: string;
  eventPeriod: string;
  eventDetectedAt: string;
  contractId: number;
  contractUid: string;
  contractTitle: string;
  insuranceProviderName: string | null;
  insuranceGroupName: string | null;
  contractGroupName: string;
  contractCreated: string;
  annualPremium: number;
}

export class EventConversionsModel {
  windowDays: number;
  eventsCount: number;
  convertedEventsCount: number;
  contractsCount: number;
  annualVolume: number;
  items: EventConversionItemModel[];
}
